<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group label="Descrição" label-for="v-description">
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="description"
                  :disabled="
                    (!verificarPermissao('ROLE_FINAN_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                  "
                />
                <small data-cy="v-description" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Comportamento de Integração -->
          <b-col cols="12" class="mb-2">
            <hr>
            <h6 class="mb-2 text-primary">Comportamento de Integração Bancária</h6>
            <b-row>
              <b-col md="4">
                <b-form-group label="Gera Boleto?" label-for="cb-gera-boleto">
                  <b-form-checkbox id="cb-gera-boleto" v-model="form.geraBoleto" switch name="check-button">
                    {{ form.geraBoleto ? 'Sim' : 'Não' }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Gera PIX?" label-for="cb-gera-pix">
                  <b-form-checkbox id="cb-gera-pix" v-model="form.geraPix" switch name="check-button">
                    {{ form.geraPix ? 'Sim' : 'Não' }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Transação em Cartão (Maquininha/POS)?" label-for="cb-transacao-cartao">
                  <b-form-checkbox id="cb-transacao-cartao" v-model="form.transacaoCartao" switch name="check-button">
                    {{ form.transacaoCartao ? 'Sim' : 'Não' }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <!-- Gateway e Encargos -->
          <b-col cols="12" class="mb-1">
            <hr>
            <h6 class="mb-1 text-primary">Gateway de Pagamento e Encargos</h6>
          </b-col>

          <b-col md="6">
            <b-form-group label="Gateway de Integração" label-for="v-gateway">
              <v-select
                id="v-gateway"
                v-model="form.configuracaoGateway"
                :reduce="(g) => ({ id: g.id })"
                label="descricao"
                :options="comboGateways"
                placeholder="Nenhum (Pagamento Manual)"
                data-cy="gateway"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4">
            <b-form-group
              label="Vincular a um Encargo"
              description="Custos operacionais que serão abatidos no documento de quitação."
            >
              <v-select
                v-model="form.encargo"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="comboEncargos"
                label="nome"
                placeholder="Selecione um encargo"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Deduzir Encargos Automaticamente?" label-for="v-deduzir">
              <b-form-checkbox
                id="v-deduzir"
                v-model="form.deduzirTaxaAutomatica"
                switch
              >
                {{ form.deduzirTaxaAutomatica ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->

          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_FINAN_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_FINAN_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import paymentGatewayServices from '@/api/financial/paymentGatewayServices'
import { encargoServices } from '@/api/financial/encargoServices'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('paymentMethodsSettingsModule', {
      paymentMethods: (state) => state.paymentMethods
    })
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue,
    vSelect,
    BFormCheckbox
  },
  directives: {
    Ripple
  },
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Forma de Pagamentos',
      required,
      comboEncargos: [],
      comboGateways: [],
      form: {
        descricao: '',
        geraBoleto: false,
        geraPix: false,
        transacaoCartao: false,
        configuracaoGateway: null,
        encargo: null,
        deduzirTaxaAutomatica: false
      }
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.paymentMethods))
    this.loadCombos()
  },
  methods: {
    async loadCombos() {
      const [gwRes, encargoRes] = await Promise.all([
        paymentGatewayServices.loadAll(),
        encargoServices.loadAll()
      ])
      this.comboGateways = gwRes.data?.content || gwRes.data || []
      this.comboEncargos = encargoRes.data?.content || encargoRes.data || []
    },
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('paymentMethodsSettingsModule/resetPaymentMethods')
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch(
                'paymentMethodsSettingsModule/editPaymentMethods',
                this.form
              )
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch(
                'paymentMethodsSettingsModule/insertNewPaymentMethods',
                this.form
              )
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        descricao: '',
        geraBoleto: false,
        geraPix: false,
        transacaoCartao: false,
        configuracaoGateway: null,
        taxa: null,
        deduzirTaxaAutomatica: false
      }
    }
  }
}
</script>
